import { t } from "i18next";
import { FieldValues, RegisterOptions, ValidationRule } from "react-hook-form";

export const MAX_UPLOAD_FILE_SIZE: number = 5e6;
export const MAX_UPLOAD_FILE_SIZE_IMPORT: number = 5e6;
// Largest amount a double still holds to 4 exact decimals; the server refuses anything above it.
export const MAX_ACTIVITY_AMOUNT: number = 99_999_999_999.9999;

export interface InputData {
  label: string;
  info: string;
}

export interface InputAuxiliary {
  emissionGroup: string;
  amount: InputData;
  auxiliary?: InputData[];
}

export const INPUT_AUXILIARY: InputAuxiliary[] = [
  {
    emissionGroup: "Fuel",
    amount: { label: "amount-of-fuel", info: "amount-of-fuel" },
  },
  {
    emissionGroup: "Energy",
    amount: { label: "Amount-of-Energy", info: "Amount-of-Energy" },
  },
  {
    emissionGroup: "Wastewater",
    amount: {
      label: "amount-of-organic-loading",
      info: "amount-of-organic-loading",
    },
    auxiliary: [
      { label: "", info: "" },
      { label: "BOD-COD-Value", info: "BOD-Value-Description" },
      { label: "Amount-of-Wastewater", info: "Amount-of-Wastewater" },
      { label: "Amount-of-Sludge", info: "Amount-of-Sludge-Description" },
    ],
  },
  {
    emissionGroup: "Refrigerants",
    amount: {
      label: "Amount-of-Refrigerants",
      info: "Amount-of-Refrigerants-Description",
    },
  },
  {
    emissionGroup: "Waste Disposal",
    amount: { label: "Waste", info: "Waste" },
    auxiliary: [{ label: "Waste-Type", info: "Waste-Type" }],
  },
  {
    emissionGroup: "Septic Tank",
    amount: {
      label: "amount-of-population-load",
      info: "amount-of-population-load",
    },
    auxiliary: [
      { label: "", info: "" },
      { label: "Person-On-site", info: "Amount-of-Persons-Description" },
      { label: "On-site-Schedule", info: "On-site-Schedule" },
      { label: "", info: "" },
    ],
  },
  {
    emissionGroup: "Fertilizer",
    amount: {
      label: "Amount-of-Key-Substance",
      info: "Amount-of-Key-Substance",
    },
  },
  {
    emissionGroup: "Business Travel",
    amount: { label: "input-amount-of-distance", info: "Distance-Description" },
    auxiliary: [
      { label: "trip-type", info: "trip-type" },
      { label: "Distance-(One-way)", info: "Distance-(One-way)" },
      { label: "Amount-Of-Employees", info: "Amount-Of-Employees-Description" },
    ],
  },
  {
    emissionGroup: "Employee Commuting",
    amount: { label: "input-amount-of-distance", info: "Distance-Description" },
    auxiliary: [
      { label: "trip-type", info: "trip-type" },
      { label: "Distance-(One-way)", info: "Distance-(One-way)" },
      { label: "Amount-Of-Employees", info: "Amount-Of-Employees-Description" },
    ],
  },
  {
    emissionGroup: "Fire Extinguishing",
    amount: {
      label: "Amount-of-Fire-Extinguishing",
      info: "Amount-of-Fire-Extinguishing-Description",
    },
  },
  {
    emissionGroup: "Other Fugitive-emissions",
    amount: {
      label: "Amount-of-OtherFugitiveEmission",
      info: "Amount-of-OtherFugitiveEmission-Description",
    },
  },
  {
    emissionGroup: "Purchases",
    amount: {
      label: "Amount-of-Purchases",
      info: "Amount-of-Purchases-Description",
    },
  },
  {
    emissionGroup: "Water",
    amount: { label: "Amount-of-Water", info: "Amount-of-Water" },
  },
  {
    emissionGroup: "Outsourcing Transport",
    amount: {
      label: "input-amount-of-distance",
      info: "input-amount-of-distance",
    },
    auxiliary: [
      { label: "Goods-Type", info: "Goods-Type-Description" },
      { label: "Distance-One-way-km", info: "Distance-One-way-km" },
      { label: "Loading-tonne", info: "Loading-tonne" },
    ],
  },
  {
    emissionGroup: "Capital Goods",
    amount: { label: "Amount", info: "Amount" },
  },
];

export const USER_STATUS = [
  {
    status: "activated",
    textColor: "var(--green)",
    bgColcor: "var(--status-approved-complete-active-bg)",
  },
  {
    status: "pending",
    textColor: "var(--status-pending-text)",
    bgColcor: "var(--status-pending-bg)",
  },
];

export const USER_ROLES = [
  { status: "admin", name: "admin" },
  { status: "user", name: "user" },
  { status: "data_entry", name: "Data-Entry" },
];

export const NUMBER_REGEX: RegExp = /^\d+(\.\d+)?$/;
export const NUMBER_ONLY_REGEX: RegExp = /^\d+$/;
export const NUMERIC_REGEX = /^-?\d*\.?\d+$/;
export const NUMERIC_WITH_COMMA_REGEX =
  /^-?(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?$/;
export const POSITIVE_NUMBER_REGEX: RegExp = /^\d+(\.\d+)?$/;

export const NAME_RUELS: ValidationRule<RegExp> = {
  value: /^[^,]*$/,
  message: t("Name-Fails-To-Match-Pattern"),
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{6,20}$/;

export const PASSWORD_RUELS: Omit<
  RegisterOptions<FieldValues, string>,
  "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
> = {
  required: t("Password-must-be-at-least-6-characters"),
  pattern: {
    value: PASSWORD_REGEX,
    message: t("password-fails-to-match-pattern"),
  },
};
